export const SaifFetch = {
  get,
  post,
};

export const API_ACTION = {
  Validate_User:
    (process.env.REACT_APP_API_BASE || "") +
    (process.env.REACT_APP_ROUTE_VALIDATE || "/invitedUser/validate"),
  Validate_Username:
    (process.env.REACT_APP_API_BASE || "") +
    (process.env.REACT_APP_ROUTE_CREDENTIALS || "/credentials/validate"),
  SecurityQuestions:
    (process.env.REACT_APP_API_BASE || "") +
    (process.env.REACT_APP_ROUTE_SECURITYQUESTIONS || "/securityquestions" ),  
  Activate_User:
    (process.env.REACT_APP_API_BASE || "") +
    (process.env.REACT_APP_ROUTE_ACTIVATE_USER || "/createUser"),
  Validate_UID:    
    (process.env.REACT_APP_API_BASE || "") +
    (process.env.REACT_APP_ROUTE_GUID || "/validate/"),
  Request_Access:
    (process.env.REACT_APP_API_BASE || "") +
    (process.env.REACT_APP_ROUTE_REQUEST_ACCESS || "/requestaccess/policyholder"),
  Pending_Steward:
    (process.env.REACT_APP_API_BASE || "") +
    (process.env.REACT_APP_ROUTE_STEWARD_PENDING || "/accessrequest"),
  Steward_Action_Eligible:
    (process.env.REACT_APP_API_BASE || "") +
    (process.env.REACT_APP_ROUTE_STEWARD_ELIGIBILITY || "/accessrequest/eligibility"),
  getPermissionMappings: 
    (process.env.REACT_APP_API_BASE || "") + ("/collections"),
    // for local use (process.env.REACT_APP_API_BASE || "") + ("/v1/permissionmaps/policyholder"),
    
};

const getResponseData = async <T>(response: Response):Promise<T | {}> => {
  let data: T | {} = {};
  
  try {
    data = await response.json();
  } catch { 
    //No response object provided
  }

  return data;
}

async function get(url: string, jwtToken: string) {
  const requestOptions = {
    method: "GET",
    crossDomain:true,
    headers: {"Content-Type": "application/json", "Authorization": jwtToken ?? ""},
    requestCredentials: "include"
  };
    const response = await fetch(url, requestOptions);
    return response;
}

async function post(url: string, jwtToken: string, body: object) {
  const requestOptions = {
    method: "POST",
    crossDomain:true,
    headers: {"Content-Type": "application/json", "Authorization": jwtToken ?? ""},
    body: JSON.stringify(body),
    requestCredentials: "include"
  };
    const response = await fetch(url, requestOptions);
    return response;
}
